import backendV2Service from './backend-v2.service';

export interface ImpersonationRequest {
    userId?: number | string;
    dni?: string;
}

export interface ImpersonationResponse {
    status?: { code?: number; name?: string };
    content?: { redirectURL?: string; token?: string };
}

export interface DataSystemImpersonationResponse {
    authenticateToken?: string;
    redirectURL?: string;
    user?: {
        id?: number | string;
        username?: string;
        email?: string;
        firstName?: string;
        lastName?: string;
        lastName2nd?: string;
        userType?: string;
        active?: boolean;
    };
}

function unwrap<T>(request: Promise<{ data: T }>): Promise<T> {
  return request.then(({ data }) => data);
}

const impersonationService = {
  impersonate(payload: ImpersonationRequest): Promise<ImpersonationResponse> {
    return unwrap(backendV2Service.post<ImpersonationResponse>('/impersonations', payload));
  },

  impersonateForDataSystem(
    payload: ImpersonationRequest,
  ): Promise<DataSystemImpersonationResponse> {
    return unwrap(
      backendV2Service.post<DataSystemImpersonationResponse>(
        '/impersonations/datasystem',
        payload,
      ),
    );
  },
};

export default impersonationService;
